import React, { useEffect, useRef, useState } from 'react';
import ButtonPrimary from '../components/ButtonPrimary';

import Cropper from 'react-cropper';

export default function InputImage({
  className,
  name,
  setValue,
  setDirty,
  hasError,
  hideUploadButton,
  defaultValue
}) {
  const inputRef = useRef(null);

  const [selectedImage, setSelectedImage] = useState('');
  const [cropData, setCropData] = useState(null);
  const [cropper, setCropper] = useState();

  // event after file selection
  const onChange = e => {
    e.preventDefault();
    const files = (
      e.dataTransfer ? e.dataTransfer.files
    : e.target  ? e.target.files
    : []
    );
    const file = files[0];

    const dataReader = new FileReader();
    const arrayReader = new FileReader();
    dataReader.onload = () => setSelectedImage(dataReader.result);
    arrayReader.onload = () => {
      const blob = new Blob([ new Uint8Array(arrayReader.result) ], {type: file.type });
      blob.name = file.name;
      setValue({ [name] : blob });
      setDirty({ [`${name}Dirty`] : true });
    }
    dataReader.readAsDataURL(file);
    arrayReader.readAsArrayBuffer(file);
  };

  const getCropData = () => {
    cropper
    .getCroppedCanvas({ maxWidth: 768 })
    .toBlob(blob => {
      // split the fake path set in the file input
      blob.name = inputRef.current.value.split('\\').pop();
      setValue({ [name] : blob });
    }, 0.9);
    setCropData(cropper.getCroppedCanvas().toDataURL());
  };

  const clearImage = () => {
    setSelectedImage(null);
    setCropData(null);
    inputRef.current.value = null;
    setValue({ [name] : null });
  }

  // set an existing image as default on the story edit page
  useEffect(() => {
    if (defaultValue) {
      setValue({ [name] : defaultValue });
      setCropData(defaultValue);
    }
  }, [ defaultValue ]);
  
  return (
  <div className={`input-image ${ className || '' }`}>
    <div className="mb24">
      <input
        className="dn"
        ref={inputRef}
        type="file"
        accept="image/*"
        name={name}
        onChange={onChange}
      />
      {!cropData && !selectedImage &&
      <div
        className={`df aic jcc mih400 w336 w100%@sm curp ${hasError ? 'bd1-d-red' : 'bd1-d-black' }`}
        onClick={() => inputRef.current.click()}
        onKeyDown={e => e.key === 'Enter' && inputRef.current.click()}
        tabIndex="0"
        role="button"
        aria-label="Upload an image"
      >
        <div className="tac">
          <div className="c-gray fz40 mb10">+</div>
          <div className="ttu fw600">Add Image</div>
        </div>
      </div>
      }
      {!cropData && selectedImage &&
      <Cropper
        style={{ height: 400, width: 330 }}
        zoomTo={0}
        initialAspectRatio={1}
        src={selectedImage}
        viewMode={1}
        minCropBoxHeight={10}
        minCropBoxWidth={10}
        background={false}
        responsive={true}
        autoCropArea={1}
        checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
        onInitialized={(instance) => {
          setCropper(instance);
        }}
        guides={true}
      />
      }
      {cropData &&
      <div className="dib posr bgc-gray-lighter w100%@sm">
        <div className="mih400 posr mah400 w336 w100%@sm oh df jcc aic"
          style={{
            backgroundImage: `url(${cropData})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
          role="img"
          aria-label="Cropped Image"
        >
        </div>
        <button
          className="t0 r0 posa curp bgc-white c-black bdn fz18 fw600"
          type="button"
          onClick={clearImage}
        >
          &times;
        </button>
      </div>
      }
    </div>
      {!selectedImage && !hideUploadButton &&
      <ButtonPrimary onClick={() => {
        inputRef.current.click();
      }}>
        Upload Button
      </ButtonPrimary>
      }
    {selectedImage &&
    <div className="df jcsb maw336 fxww g16">
      {!cropData &&
      <ButtonPrimary
        compact={true}
        onClick={getCropData}
      >
        Crop Image
      </ButtonPrimary>
      }
      <ButtonPrimary
        compact={true}
        onClick={clearImage}
      >
        Clear Image
      </ButtonPrimary>
    </div>
    }
  </div>
  )
};
